import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function CTAFinal() {
  const { t } = useTranslation('homepage');
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.15);

  const scrollToForm = () => {
    const element = document.getElementById('quote-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="cta-final" className="bg-copper py-20 md:py-28 lg:py-32">
      <div
        ref={ref}
        className={`max-w-3xl mx-auto px-4 md:px-6 lg:px-10 text-center transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
      >
        <h2 className="font-manrope font-bold text-white text-2xl md:text-3xl lg:text-4xl xl:text-5xl mb-4 leading-tight">
          {t('cta_h2')}
        </h2>
        <p className="text-white/85 text-base md:text-lg lg:text-xl mb-10 max-w-xl mx-auto">
          {t('cta_subtitle')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={scrollToForm}
            className="group bg-white hover:bg-soft-gray text-slate-primary font-bold px-8 py-4 rounded-md text-base md:text-lg transition-all duration-300 flex items-center gap-3 shadow-lg whitespace-nowrap"
          >
            {t('cta_button')}
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
          </button>
          <a
            href="tel:+14184769950"
            aria-label="Appeler Couvreur-Lévis.com au 418-476-9950"
            title="Cliquez pour appeler"
            className="flex items-center gap-3 border-2 border-white/60 hover:border-white text-white font-medium px-6 py-4 rounded-md text-base transition-all duration-300 whitespace-nowrap"
          >
            <span className="w-10 h-10 flex items-center justify-center rounded-full bg-white/20">
              <i className="ri-phone-line" />
            </span>
            {t('cta_phone')}
          </a>
        </div>
      </div>
    </section>
  );
}